import { useEffect, useState } from 'react'

/**
 * Modo de posición REAL de una cuenta (lectura en vivo del exchange).
 * `fetchMode(accountId)` devuelve la promesa del endpoint (axios o publicApi,
 * ambos resuelven `{ data: { position_mode } }`). Estados:
 *   status 'loading' | 'ok' (mode = 'HEDGE'|'ONE_WAY') | 'na' (exchange sin
 *   este concepto modelado, o fallo de lectura: fail-soft, nunca bloquea).
 * `setMode` deja al llamador reflejar un cambio confirmado sin releer.
 */
export function usePositionMode(accountId, fetchMode) {
  const [state, setState] = useState({ status: 'loading', mode: null })

  useEffect(() => {
    if (!accountId) { setState({ status: 'na', mode: null }); return undefined }
    let cancelled = false
    setState({ status: 'loading', mode: null })
    fetchMode(accountId)
      .then(({ data }) => {
        if (cancelled) return
        const mode = data?.position_mode
        setState(mode === 'HEDGE' || mode === 'ONE_WAY' ? { status: 'ok', mode } : { status: 'na', mode: null })
      })
      .catch(() => { if (!cancelled) setState({ status: 'na', mode: null }) })
    return () => { cancelled = true }
  }, [accountId, fetchMode])

  return { ...state, setMode: (mode) => setState({ status: 'ok', mode }) }
}
